import { Field, FieldProps, getIn } from 'formik';
import { ReactNode } from 'react';

import { Radio } from '../../components';

interface Props {
  name: string;
  label?: ReactNode;
  options: Array<{
    custom?: boolean;
    label: ReactNode;
    value: string | number | boolean;
  }>;
  type?: 'horizontal' | 'vertical';
  breakLabel?: boolean; // If radio has long label, so it breaks label and centers radio button itself
}

export default function RadioField({ name, ...bag }: Props) {
  return (
    <Field name={name}>
      {({ field: { ...fieldBag }, form }: FieldProps) => {
        const handleChange = (e: string | number | boolean) => {
          form.setFieldValue(name, e);
        };

        return (
          <div>
            <Radio error={getIn(form.errors, name)} {...fieldBag} {...bag} onChange={handleChange} />
          </div>
        );
      }}
    </Field>
  );
}
